<template>
    <div>
        <PreLoader v-if="isLoading"/>
        <SuperAdminSchoolHead style="align-items: flex-start" class="sas-head">
            <template v-slot:title><span class="sas-title" v-html="$t('declarations')"/></template>
        </SuperAdminSchoolHead>
        <div class="scl-ad">
            <SmartTable :schools="announcements" :current-page="currentPage" :page-size="announcements.length"
                        :total-elements="totalElements" :totalPages="totalPages"
                        @leftClick="onPageChange('left')" @rightClick="onPageChange('right')">
                <template v-slot:firstItem>
                    <div class="sas-head-center-block">
                        <v-select class="v-select-item" :label="$t('role')" :items="roles" item-value="code" outlined
                                  dense item-text="title" v-model="announceObj.roleType" @change="fetchAnnouncements"/>
                        <v-btn color="primary" @click="openAnnouncementModal('create', {})"
                               v-text="`Добавить объявление`"/>
                    </div>
                </template>
                <template v-slot:head>
                    <th v-html="$t('title')"/>
                    <th v-html="$t('description')"/>
                    <th/>
                    <th/>
                </template>
                <template v-slot:body="{item}">
                    <td v-html="item['title']"/>
                    <td v-html="item['content']"/>
                    <td>
                        <v-btn icon text color="primary" @click="openAnnouncementModal('update', item)">
                            <v-icon color="primary">mdi mdi-pencil-outline</v-icon>
                        </v-btn>
                    </td>
                    <td>
                        <v-btn icon text color="red" @click="deleteItem(item, true)">
                            <v-icon color="red">mdi mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </td>
                </template>
            </SmartTable>
        </div>
        <v-dialog v-model="announDialog">
            <v-card class="pad-20 card-style">
                <h4 v-html="mode === 'create' ? $t('addDeclaration') : $t('edit')"/>
                <v-form ref="announceForm">
                    <v-text-field outlined dense :rules="required" :label="$t('title')"
                                  v-model="announceObj.title"/>
                    <v-textarea outlined dense :rules="required" :label="$t('description')"
                                v-model="announceObj.content"/>
                    <div class="btn-actions">
                        <v-btn color="primary" @click="closeModal" v-text="$t('cancel')"/>
                        <v-btn color="green" @click="submitSave" v-text="$t('save')"/>
                    </div>
                </v-form>
            </v-card>
        </v-dialog>
        <!--DELETE MODAL-->
        <v-dialog v-model="deleteDialog">
            <v-card  class="pad-20">
                <h4 v-html="`Удалить ?`"/>
                <div class="btn-actions">
                    <v-btn color="primary" @click="deleteDialog = false">{{ $t('cancel') }}</v-btn>
                    <v-btn color="red" @click="deleteItem('','')">{{ $t('remove') }}</v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import PreLoader from '@/components/preloader/PreLoader'
import AnnouncementService from '@/_services/announcement.service'

export default {
    components: {SuperAdminSchoolHead, SmartTable, PreLoader},
    data () {
        return {
            required: [v => !!v || this.$t('required')],
            roles: [
                { title: this.$t('ROLE_ADMIN'), code: 'ADMIN' }
            ],
            announceObj: {
                bySuperAdmin: true,
                classId: '',
                content: '',
                roleType: '',
                schoolId: '',
                title: '',
                userId: 0
            },
            mode: '',
            isLoading: false,
            announDialog: false,
            deleteDialog: false,
            announcements: [],
            totalPages: 1,
            totalElements: 0,
            currentPage: 1
        }
    },
    computed: {
        userProfile () {
            return this.$store.state.account.profile
        }
    },
    created () {
        this.announceObj.userId = this.userProfile.user.id
        this.announceObj.roleType = this.roles[0].code
        this.fetchAnnouncements()
    },
    methods: {
        fetchAnnouncements (page = 0) {
            this.isLoading = true
            this.announcements = []
            AnnouncementService.getAllAnnouncementsByRole(this.announceObj.roleType, page)
                .then((res) => {
                    if (res['_embedded']) {
                        this.announcements = res['_embedded']['announcementResourceList']
                        this.totalPages = res.page.totalPages
                        this.totalElements = res.page.totalElements
                        this.currentPage = res.page.number + 1
                    }
                    this.isLoading = false
                })
                .catch((err) => {
                    this.$toast.error(err)
                    this.isLoading = false
                })
        },
        openAnnouncementModal (mode, announce) {
            this.mode = mode
            if (mode === 'create') {
                this.announceObj.title = ''
                this.announceObj.content = ''
            } else {
                this.announceObj.title = announce.title
                this.announceObj.content = announce.content
                this.announceObj.userId = this.userProfile.user.id
                this.announceObj.id = announce.id
            }
            this.announDialog = true
        },
        closeModal () {
            this.announDialog = false
        },
        onPageChange (nav) {
            nav === 'left' ? this.currentPage -= 1 : this.currentPage += 1
            this.fetchAnnouncements(this.currentPage - 1)
        },
        submitSave () {
            if (this.$refs.announceForm.validate()) {
                this.isLoading = true
                AnnouncementService[this.mode](this.announceObj).then(() => {
                    this.isLoading = false
                    this.$toast.success(this.$t('success'))
                    this.closeModal()
                    this.fetchAnnouncements(this.currentPage - 1)
                }).catch((err) => {
                    this.isLoading = false
                    this.$toast.error(err)
                })
            }
        },
        deleteItem (announce, confirm) {
            if (confirm) {
                this.announceObj.id = announce.id
                this.deleteDialog = true
            } else {
                this.isLoading = true
                AnnouncementService.remove(this.announceObj.id).then(() => {
                    this.deleteDialog = false
                    this.$toast.success(this.$t('successDeleted'))
                    this.fetchAnnouncements()
                }).catch((err) => {
                    this.isLoading = false
                    this.$toast.error(err)
                })
            }
        },
        toggleDeleteModal () {
            this.deleteDialog = false
        }
    }
}
</script>

<style lang="scss" scoped>
    .card-style {
        min-width: 500px;
    }
</style>
